import BackgroundImage from "./assets/background_img.png";
import "./App.css";
import FeatherIcon from "feather-icons-react";
import React, { useEffect, useState } from "react";
import showNotification from "./Notification";

const BANK_DETAILS = {
	bankName: "UBL",
	accountTitle: "Muhammad Munaf Ul Hassan",
	accountNumber: "1954298987607",
	ibanNumber: "PK09UNIL0109000298987607",
};

const BUTTON_COPY_VALUE = BANK_DETAILS.accountNumber;

const CopyField = ({ label, value, isCopiable }) => {
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (isCopied) {
			const timeout = setTimeout(() => {
				setIsCopied(false);
			}, 2000);
			return () => clearTimeout(timeout);
		}
	}, [isCopied]);

	const copyValue = async () => {
		if (!isCopiable) return;

		try {
			await navigator.clipboard.writeText(value);
			setIsCopied(true);
			showNotification("Copied!", 2000);
			console.log("Copied!");
		} catch (err) {
			console.error("Failed to copy!", err);
		}
	};

	return (
		<div className="copy-field v2" onClick={copyValue}>
			<div className="column">
				<p className="label">{label}</p>
				<p className="value">{value}</p>
			</div>
			{isCopiable && (
				<FeatherIcon
					icon={isCopied ? "check" : "copy"}
					className="copy-icon"
					size={20}
				/>
			)}
		</div>
	);
};

function App() {
	const [buttonClicked, setButtonClicked] = useState(false);

	useEffect(() => {
		if (buttonClicked) {
			const timeout = setTimeout(() => {
				setButtonClicked(false);
			}, 4000);
			return () => clearTimeout(timeout);
		}
	}, [buttonClicked]);

	return (
		<div className="container">
			<div className="card">
				<img src={BackgroundImage} alt="cover" />
				<div className="card-content">
					<div className="main-content">
						<div>
							<h2
								style={{
									fontFamily: "Manrope",
									fontSize: "14px",
									fontWeight: "800",
									letterSpacing: "-0.8px",
									color: "#FF6200",
									lineHeight: "16px",
								}}
							>
								Meras e Khizr
							</h2>
							<h1
								style={{
									fontFamily: "Manrope",
									fontSize: "32px",
									fontWeight: "900",
									letterSpacing: "-2px",
									color: "#C84912",
									lineHeight: "40px",
								}}
							>
								Your Donations Matter
							</h1>
							<p
								style={{
									fontFamily: "Manrope",
									fontSize: "12px",
									fontWeight: "500",
									letterSpacing: "-0.25px",
									color: "#667085",
									lineHeight: "16px",
									marginTop: 4,
								}}
							>
								People are counting on you
							</p>
						</div>

						<div className="divider"></div>

						<div className="bank-data">
							<CopyField
								label="Bank Name"
								value={BANK_DETAILS.bankName}
							/>
							<CopyField
								label="Account Title"
								value={BANK_DETAILS.accountTitle}
							/>
							<CopyField
								label="Account Number"
								value={BANK_DETAILS.accountNumber}
								isCopiable
							/>
							<CopyField
								label="IBAN Number"
								value={BANK_DETAILS.ibanNumber}
								isCopiable
							/>
						</div>
					</div>

					<button
						className={`button ${buttonClicked ? "clicked" : ""}`}
						onClick={() => {
							showNotification("Copied account number!", 2000);
							navigator.clipboard.writeText(BUTTON_COPY_VALUE);
							setButtonClicked(true);
						}}
					>
						{buttonClicked
							? "Thank you for donating!"
							: "Copy Account Number"}{" "}
						<FeatherIcon
							icon={buttonClicked ? "check" : "copy"}
							size={16}
							className="btn-icon"
						/>
					</button>
				</div>
			</div>
		</div>
	);
}

export default App;
